import { motion } from "framer-motion";
import { DOCTOR, BRAND } from "@/lib/constants";

export const About = () => {
  return (
    <section
      data-testid="about-section"
      className="bg-[#F8FAFC] relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-24 lg:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-4">
            <div className="font-mono text-[10px] uppercase tracking-widest-plus text-[#B08A4A] mb-4">
              01 — Chief Pathologist
            </div>
            <h2 className="font-serif text-4xl md:text-5xl leading-[1.05] text-[#0A2540]">
              A career spent between the{" "}
              <span className="italic">microscope</span> and the{" "}
              <span className="italic text-[#2E5AA5]">bedside</span>.
            </h2>
          </div>

          <div className="lg:col-span-5">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              className="space-y-5 font-sans text-base text-[#475569] leading-[1.85]"
            >
              {DOCTOR.bio.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
              <p className="font-serif italic text-2xl text-[#0A2540] pt-4 border-l-2 border-[#B08A4A] pl-6">
                &ldquo;{BRAND.motto}&rdquo;
              </p>
            </motion.div>
          </div>

          <div className="lg:col-span-3">
            <div className="border-l border-[#B08A4A]/50 pl-6 space-y-8">
              <div>
                <div className="font-mono text-[10px] uppercase tracking-widest-plus text-[#94A3B8] mb-2">
                  Distinction
                </div>
                <div className="font-serif text-2xl text-[#B08A4A] leading-tight">
                  Gold Medalist
                  <br />
                  <span className="text-[#0A2540] text-base italic font-normal">
                    MD, Pathology
                  </span>
                </div>
              </div>
              <div>
                <div className="font-mono text-[10px] uppercase tracking-widest-plus text-[#94A3B8] mb-2">
                  Current Post
                </div>
                <div className="font-serif text-lg text-[#0A2540] leading-snug italic">
                  {DOCTOR.currentPost}
                </div>
                <div className="font-sans text-xs text-[#475569] italic mt-2">
                  {DOCTOR.previousPost}
                </div>
              </div>
              <div>
                <div className="font-mono text-[10px] uppercase tracking-widest-plus text-[#94A3B8] mb-2">
                  Training
                </div>
                <div className="font-serif text-base text-[#0A2540] leading-snug italic">
                  {DOCTOR.training}
                </div>
                <div className="mt-3 pl-3 border-l border-[#B08A4A]/50">
                  <div className="font-mono text-[9px] uppercase tracking-widest-plus text-[#B08A4A] mb-1">
                    International Observership
                  </div>
                  <div className="font-serif text-sm text-[#0A2540] leading-snug italic">
                    Department of Pathology
                    <br />
                    National University of Singapore (NUS)
                  </div>
                </div>
              </div>
              <div>
                <div className="font-mono text-[10px] uppercase tracking-widest-plus text-[#94A3B8] mb-2">
                  Focus Areas
                </div>
                <ul className="space-y-1 font-sans text-sm text-[#475569]">
                  <li>— Histopathology & IHC</li>
                  <li>— Cytology & FNAC</li>
                  <li>— Hematopathology</li>
                  <li>— B2B Diagnostic Advisory</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
